export const paths = {
  followingPath: '/home',
  mySpacePath: '/',
  // mySpaceNewsPath: '/myspace/news',
  // mySpaceDocumentsPath: '/myspace/documents',
  workspacePath: '/workspace',
  workspacePlatformPath: '/platform-hub',
  followingCategoryPath: '/home?category=:category',
  // mySpaceCategoryPath: '/myspace/home?category=:category',
  startPagePath: '/start',
  // newPath: '/news/daily',
  defaultCategoryPath: '/category/:category',
  categoryPath: '/category/:category',
  codiRowPath: '/book/:codi_document_id/detail',
}
